<div class="container p-0" *ngIf="loading">
    <div class="row border-bottom align-items-center d-none">
        <div class="col-6">
            <div class="d-flex align-items-center">
                <div>
                    <div class="animate w-40 h-10"></div>
                    <div class="animate w-225 h-12 c-mt-14"></div>
                </div>
                <div class="d-flex align-items-center c-ml-82">
                    <div class="animate w-20 h-20 c-mr-10"></div>
                    <div class="animate w-64 h-12"></div>
                </div>
            </div>
        </div>
        <div class="col-6 text-right">
            <div class="d-flex align-items-center justify-content-end">
                <div class="d-flex align-items-center">
                    <div class="animate w-16 h-16 c-mr-5"></div>
                    <div class="animate w-28 h-12"></div>
                </div>
                <div class="d-flex align-items-center c-ml-20">
                    <div class="animate w-16 h-16 c-mr-5"></div>
                    <div class="animate w-28 h-12"></div>
                </div>
                <div class="c-ml-42">
                    <div class="animate w-225 h-64"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- List View -->
    <ng-container *ngIf="!isCardView">
        <div class="row border-bottom list-view-mobile" *ngFor="let i of [].constructor(5)">
            <div class="col-lg-4 col-md-12 col-12 mobile-list-spacing">
                <div class="d-flex align-items-center c-mb-20 justify-content-between">
                    <div>
                        <div class="w-225 h-20 animate border-radius-25px"></div>
                        <div class="w-134 h-20 c-mt-10 animate border-radius-25px"></div>
                    </div>
                    <div>
                        <div class="w-54 h-12 animate border-radius-25px"></div>
                        <div class="w-99 h-20 c-mt-10 animate border-radius-25px"></div>
                    </div>
                </div>
                <div class="w-100 h-5 animate"></div>
                <div class="text-right">
                    <div class="w-54 h-12 animate border-radius-25px c-mt-5 ml-auto"></div>
                </div>
            </div>
            <div class="col-lg-6 col-md-8 col-8">
              <div class="handle-column">
                <div class="d-inline-flex align-items-center justify-content-between">
                    <div>
                        <div class="w-54 h-12 animate border-radius-25px"></div>
                        <div class="w-99 h-20 c-mt-10 animate border-radius-25px"></div>
                    </div>
                    <div class="c-ml-49">
                        <div class="w-54 h-12 animate border-radius-25px"></div>
                        <div class="w-99 h-20 c-mt-10 animate border-radius-25px"></div>
                    </div>
                </div>
                <div class="d-inline-flex align-items-center justify-content-between second-element">
                    <div>
                        <div class="w-54 h-12 animate border-radius-25px"></div>
                        <div class="w-99 h-20 c-mt-10 animate border-radius-25px"></div>
                    </div>
                    <div class="c-ml-49">
                        <div class="w-54 h-12 animate border-radius-25px"></div>
                        <div class="w-186 h-20 c-mt-10 animate border-radius-25px"></div>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-4">
                <div class="d-flex align-items-center justify-content-end">
                    <div class="w-32 h-32 animate c-user--icon rounded-circle"></div>
                    <div class="w-32 h-32 animate c-user--icon rounded-circle"></div>
                    <div class="w-32 h-32 animate c-user--icon rounded-circle isOverlap"></div>
                    <div class="w-32 h-32 animate c-user--icon rounded-circle isOverlap"></div>
                </div>
                <div class="w-44 h-44 animate ml-auto c-mt-15"></div>
            </div>
        </div>
    </ng-container>

    <!-- Grid View -->
    <ng-container *ngIf="isCardView">
        <div class="row">
            <div class="col-12">
                <div class="dashboard__grid border-0">
                    <div class="row dashboard_grid__row m-0">
                        <div class="col-lg-4 col-md-6 col-12 dashboard_grid__box" *ngFor="let i of [].constructor(5)">
                            <div class="d-flex align-items-center c-mb-20 justify-content-between">
                                <div>
                                    <div class="w-225 h-20 animate border-radius-25px"></div>
                                    <div class="w-134 h-20 c-mt-10 animate border-radius-25px"></div>
                                </div>
                                <div>
                                    <div class="w-54 h-12 animate border-radius-25px"></div>
                                    <div class="w-99 h-20 c-mt-10 animate border-radius-25px"></div>
                                </div>
                            </div>
                            <div class="w-100 h-5 animate"></div>
                            <div class="text-right">
                                <div class="w-54 h-12 animate border-radius-25px c-mt-5 ml-auto"></div>
                            </div>
                            <div class="row c-mb-44 c-mt-15">
                                <div class="col-6">
                                    <div class="w-80 h-12 c-mb-16 animate border-radius-25px"></div>
                                    <div class="w-134 h-16 animate border-radius-25px"></div>
                                </div>
                                <div class="col-6">
                                    <div class="w-80 h-12 c-mb-16 animate border-radius-25px"></div>
                                    <div class="w-134 h-16 animate border-radius-25px"></div>
                                </div>
                            </div>
                            <div class="row c-mb-30 c-mt-20">
                                <div class="col-6">
                                    <div class="w-80 h-12 c-mb-16 animate border-radius-25px"></div>
                                    <div class="w-134 h-16 animate border-radius-25px"></div>
                                </div>
                                <div class="col-6">
                                    <div class="w-80 h-12 c-mb-16 animate border-radius-25px"></div>
                                    <div class="w-100 h-16 animate border-radius-25px"></div>
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <div class="d-flex align-items-center">
                                        <div class="w-34 h-34 animate c-user--icon rounded-circle"></div>
                                        <div class="w-34 h-34 animate c-user--icon rounded-circle"></div>
                                        <div class="w-34 h-34 animate c-user--icon rounded-circle isOverlap"></div>
                                        <div class="w-34 h-34 animate c-user--icon rounded-circle isOverlap"></div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="w-44 h-44 animate ml-auto"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12 dashboard_grid__box" *ngFor="let i of [].constructor(1)">
                            <div class="h-250 w-100"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
